import { Colors, Spacing, StateColors } from '@lichtblick/theme';
import styled from 'styled-components';
import { Text } from '../../atoms/Text/Text';
const colorMap = {
    default: Colors.DarkGray,
    error: StateColors.Error,
    success: StateColors.Success
};
export const StyledFieldFooter = styled(Text).attrs({
    size: 'Xs'
})`
  align-items: center;
  color: ${({ $fieldFooterType = 'default' })=>colorMap[$fieldFooterType]};
  display: flex;
  line-height: 170%;
`;
export const IconWrapper = styled.span`
  margin-right: ${Spacing.Xxs};
  position: relative;

  & > * {
    vertical-align: middle;
  }
`;

//# sourceMappingURL=FieldFooter.styles.js.map